import * as yup from "yup";

export const SubscriptionCommissionSchema = yup.object().shape({
  employee_id: yup.string().required("Funcionário obrigatório"),

  startDate: yup
    .date()
    .typeError("Data inicial inválida")
    .required("Data inicial obrigatória"),

  endDate: yup
    .date()
    .typeError("Data final inválida")
    .required("Data final obrigatória"),

  payment_method_id: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null
        ? null
        : Number(originalValue),
    )
    .nullable()
    .when("$isSettlement", {
      is: true,
      then: (schema) =>
        schema
          .typeError("Método de pagamento obrigatório na baixa")
          .required("Método de pagamento obrigatório na baixa"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

  paid_at: yup
    .date()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null
        ? null
        : new Date(originalValue),
    )
    .nullable()
    .when("$isSettlement", {
      is: true,
      then: (schema) =>
        schema
          .typeError("Data de pagamento obrigatória na baixa")
          .required("Data de pagamento obrigatória na baixa"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
});
